module.exports = __webpack_public_path__ + "img/tablet-2m.024736f6.svg";